import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';

class UserTimeTrackingService extends BaseRepository {
    public collection = 'rrhh/staff_schedule';
    public version = 'v1';

    public async checkUser(params) {
        return await this.request({url:"checkUser",query:params, method: "POST"});
    }

}

export default new UserTimeTrackingService(axiosInstance);
